import React from 'react';
import { Link } from 'react-router-dom';

class Login extends React.Component {
    render() {
        return (
            <div className="Login">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6 offset-md-3">
                            <div className="form-container">
                                <form>
                                    <div className="form-header">
                                        <h5 className="form-title text-center">Welcome to Dopshub</h5>
                                    </div>
                                    <div className="form-content">
                                        <div className="form-group">
                                            <label for="email">Username or Email</label>
                                            <input type="email" className="form-control" id="email" autoFocus required/>
                                        </div>
                                        <div className="form-group">
                                            <label for="pwd">Password</label>
                                            <input type="password" className="form-control" id="pwd" required/>
                                        </div>
                                        <div className="form-group form-check">
                                            <label className="form-check-label">
                                            <input className="form-check-input" type="checkbox" /> Remember me
                                            </label>
                                        </div>
                                        <button type="submit" className="btn btn-lg btn-danger">Sign In</button>
                                        <div className="form-links">
                                            <Link to="/dashboard" >Forgot your password?</Link>
                                            <Link to="/register" className="right-link">Need an Account? Register</Link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;